/**
 * Switch user on a shared device (kid-first redesign step 6d review). When a grown-up's own login
 * was parked to let PIN members take turns, pressing "Switch user" may only bring that login back
 * for the person it belongs to — they already proved who they are with their own PIN. Anyone else
 * (a child, another adult, a second parent) just ends their turn and sees "Who are you?", with the
 * login staying parked. A parked session without a recorded owner is never restored this way.
 */
export function mayRestoreParkedLogin(
  parked: { access_token?: string; user?: { id?: string } } | null | undefined,
  currentUserId: string | null | undefined,
): boolean {
  if (!parked?.access_token) return false;
  const owner = parked.user?.id;
  return !!owner && !!currentUserId && owner === currentUserId;
}
